import React from 'react'
import { Link, useForm, usePage } from '@inertiajs/inertia-react'
import { hasPermission } from '../../../utils/Permissions'
import AlertDismissible from '../../../Shared/Components/AlertDismissible'
import Breadcrumbs from '../../../Shared/Components/Breadcrumbs'
import Layout from '../../../Shared/Layout/LayoutAdmin'
import PaginationList from '../../../Shared/Components/PaginationList'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Table from 'react-bootstrap/Table'

function formatDate(val) {
    if (!val) return ''
    const d = String(val).slice(0, 10)
    const [y, m, day] = d.split('-')
    return `${day}/${m}/${y}`
}

const ClaimRecordIndex = ({ entries, filters }) => {
    const { flash } = usePage().props
    const filterForm = useForm({ search: filters.search || '' })
    const rows = entries.data || []

    const submitFilters = (e) => {
        e.preventDefault()
        filterForm.get(route('claims.records.index'), { preserveState: true })
    }

    return (
        <Row>
            {flash?.success && <AlertDismissible message={flash.success} type="success" />}
            <Col xs={12}><Breadcrumbs currentPath="admin/claims/records" /></Col>
            <Col xs={12} className="mb-4">
                <Card>
                    <Card.Header className="border-0 pt-6 d-flex justify-content-between align-items-center flex-wrap gap-2">
                        <Card.Title className="fw-bold mb-0">SINIESTROS — Registros</Card.Title>
                        {hasPermission('claims.records.create') && (
                        <Link href={route('claims.records.create')} className="btn btn-primary btn-sm">Agregar registro</Link>
                        )}
                    </Card.Header>
                    <Card.Body>
                        <Form onSubmit={submitFilters} className="row g-3 mb-4">
                            <Col md={4}>
                                <Form.Control placeholder="Buscar póliza, asegurado, folio..." value={filterForm.data.search} onChange={(e) => filterForm.setData('search', e.target.value)} />
                            </Col>
                            <Col md="auto"><Button type="submit" variant="secondary">Buscar</Button></Col>
                        </Form>
                        <Table responsive striped bordered hover size="sm">
                            <thead>
                                <tr>
                                    <th>Oficina solicita</th>
                                    <th>Oficina tramita</th>
                                    <th>Asegurado</th>
                                    <th>Beneficio</th>
                                    <th>Póliza</th>
                                    <th>Recepción</th>
                                    <th>Ingreso INBURSA</th>
                                    <th>Estatus</th>
                                    <th>Actualización</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row) => (
                                    <tr key={row.id}>
                                        <td>{row.requesting_office?.nombre}</td>
                                        <td>{row.processing_office?.nombre}</td>
                                        <td>{row.insured_name}</td>
                                        <td>{row.benefit?.name}</td>
                                        <td>{row.policy_number}</td>
                                        <td>{formatDate(row.office_reception_date)}</td>
                                        <td>{formatDate(row.inbursa_entry_date)}</td>
                                        <td>{row.status?.name}</td>
                                        <td>{formatDate(row.updated_at)}</td>
                                        <td>
                                            {hasPermission('claims.records.edit') && (
                                            <Link href={route('claims.records.edit', row.id)} className="btn btn-sm btn-light-primary">Editar</Link>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <PaginationList links={entries.links} filters={{ search: filters.search || undefined }} />
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )
}

ClaimRecordIndex.layout = (page) => <Layout title="Siniestros">{page}</Layout>

export default ClaimRecordIndex
